export default function (x) {
  return function () {
    return x;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-interpolate@1.1.6@d3-interpolate/src/constant.js
// module id = 93
// module chunks = 0